import React from "react";
import { Alert } from "@mui/material";
import { useAuth } from "hooks/useAuth";

/**
 * Zip-slot advertiser pages: Institution Leader or Marketing Executive only.
 * FDE / facility users who land on these routes via a shared dashboard tree
 * must not get advertising authority.
 */
export function ZipSlotAdsGate({ children }) {
  const { canManageZipSlotAds } = useAuth();
  if (!canManageZipSlotAds) {
    return (
      <Alert severity="warning">
        Zip-slot advertising is available to Institution Leaders and Marketing
        Executives only.
      </Alert>
    );
  }
  return children;
}

export default ZipSlotAdsGate;
